<div class="tableTitleDs__cont">
  <ng-container *ngIf="data?.Title">
    <div class="tableTitleDs__title">
      <app-ds-typography
        [size]="fontSize.XXS"
        [color]="fontColor.Invert"
        [text]="data?.Title">
      </app-ds-typography>
    </div>
  </ng-container>
  <ng-container *ngIf="data?.Columns?.length">
    <table aria-describedby="table" class="tableTitleDs__table">
      <tr class="tableTitleDs__table tableTitleDs__table--columns">
        <ng-container *ngFor="let column of data.Columns; trackBy: trackById; last as isLastColumn">
          <th scope="column" class="tableTitleDs__table-column">
            <div class="tableTitleDs__table-column-titles" [class.emit-value]="data?.EmitValue" [class.last-column]="isLastColumn">
              <div class="tableTitleDs__table-column-title">
                <app-ds-typography
                  [size]="fontSize.Minor"
                  [color]="fontColor.Secondary"
                  [fontFamily]="fontFamily.SemiBold"
                  [text]="column.Title">
                </app-ds-typography>
              </div>
              <ng-container *ngIf="column.Subtitle">
                <div class="tableTitleDs__table-column-subtitle">
                  <app-ds-typography
                    [size]="fontSize.Minor"
                    [color]="fontColor.Secondary"
                    [fontFamily]="fontFamily.SemiBold"
                    [text]="column.Subtitle">
                  </app-ds-typography>
                </div>
              </ng-container>
            </div>
          </th>
        </ng-container>
      </tr>
      <tr *ngIf="data?.Columns?.length">
        <th scope="divider" class="tableTitleDs__divider" [attr.colspan]="data.Columns.length">
          <app-ds-divider></app-ds-divider>
        </th>
      </tr>
      <ng-container *ngIf="rowsByColumns?.length">
        <ng-container *ngFor="let rows of rowsByColumns; trackBy: trackById; last as isLastColumn; index as rowViewId">
          <tr class="tableTitleDs__table-column-row" [ngStyle]="{ cursor: data?.EmitValue ? 'pointer' : null }">
            <ng-container *ngFor="let row of rows; trackBy: trackById; last as isLastRow; index as colViewId">
              <td class="tableTitleDs__table-row" [class.recommended]="row.IsRecommended" (click)="emit(rowViewId, colViewId)">
                <div class="tableTitleDs__table-row-info" [class.emit-value]="data?.EmitValue" [class.last-row]="isLastRow">
                  <div class="tableTitleDs__table-row-info-titles" [class.last-row]="isLastRow">
                    <app-ds-typography
                      [size]="fontSize.XXXS"
                      [fontFamily]="fontFamily.SemiBold"
                      [color]="fontColor.Primary"
                      [text]="row.Title">
                    </app-ds-typography>
                    <ng-container *ngIf="row.Subtitle">
                      <app-ds-typography
                        [size]="fontSize.XXXS"
                        [color]="row.SubtitleIsHiHighlight ? fontColor.Success : fontColor.Secondary"
                        [text]="row.Subtitle">
                      </app-ds-typography>
                    </ng-container>
                  </div>
                  <ng-container *ngIf="isLastRow">
                    <ng-container *ngIf="data?.EmitValue">
                      <app-ds-icon
                        class="tableTitleDs__table-row-info-icon"
                        [icon]="rowActionIcon"
                        [size]="20">
                      </app-ds-icon>
                    </ng-container>
                  </ng-container>
                </div>
              </td>
            </ng-container>
          </tr>
          <ng-container *ngIf="!isLastColumn">
            <th scope="divider" class="tableTitleDs__divider" [attr.colspan]="data.Columns.length">
              <app-ds-divider></app-ds-divider>
            </th>
          </ng-container>
        </ng-container>
      </ng-container>
    </table>
  </ng-container>
</div>